"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCellKeyboardControls = void 0;
var noop_1 = __importDefault(require("lodash/noop"));
/**
 * Hook for controlling focus of the spreadsheet from the keyboard
 * this hooks accesses the DOM directly since that's the simpler way for achieving this
 *
 * We intercept each arrow keydown and move the focus to the closest cell
 */
function useCellKeyboardControls(_a) {
    var _b = _a.onEnter, onEnter = _b === void 0 ? noop_1.default : _b, _c = _a.onChangeFocus, onChangeFocus = _c === void 0 ? noop_1.default : _c;
    return {
        onBlur: function (event) {
            if (!(event.relatedTarget instanceof HTMLElement)) {
                return;
            }
            // if we lose focus of the cell but it's still its children (CellPopover render as a children)
            // we just keep the focused state
            if (event.currentTarget.contains(event.relatedTarget) || event.currentTarget === event.relatedTarget) {
                return;
            }
            onChangeFocus(event);
        },
        onKeyDown: function (event) {
            // if current focused element is not the cell, we can ignore it
            if (document.activeElement !== event.currentTarget) {
                return;
            }
            if (event.key === 'ArrowRight') {
                if (event.currentTarget.nextSibling instanceof HTMLElement) {
                    onChangeFocus(event);
                    event.currentTarget.nextSibling.focus();
                    return;
                }
            }
            if (event.key === 'ArrowLeft') {
                if (event.currentTarget.previousSibling instanceof HTMLElement) {
                    onChangeFocus(event);
                    event.currentTarget.previousSibling.focus();
                    return;
                }
            }
            var cellIndex = event.currentTarget.getAttribute('data-cellindex');
            if (event.key === 'ArrowDown') {
                // the row is always the parent element of a cell
                var row = event.currentTarget.parentElement;
                var nextRow = row === null || row === void 0 ? void 0 : row.nextSibling;
                if (nextRow instanceof HTMLElement) {
                    var targetCell = nextRow.querySelector("[data-cellindex=\"".concat(cellIndex, "\"]"));
                    if (targetCell instanceof HTMLElement) {
                        onChangeFocus(event);
                        targetCell.focus();
                        return;
                    }
                }
            }
            if (event.key === 'ArrowUp') {
                var row = event.currentTarget.parentElement;
                var previousRow = row === null || row === void 0 ? void 0 : row.previousSibling;
                if (previousRow instanceof HTMLElement) {
                    var targetCell = previousRow.querySelector("[data-cellindex=\"".concat(cellIndex, "\"]"));
                    if (targetCell instanceof HTMLElement) {
                        onChangeFocus(event);
                        targetCell.focus();
                        return;
                    }
                }
            }
            // if the cell is selected and the user presses Esc, we should blur the focus
            // TODO: consider removing this as it's not necessarily a good UX
            if (event.key === 'Escape') {
                var activeElement = document.activeElement;
                if (activeElement && activeElement instanceof HTMLElement) {
                    activeElement.blur();
                }
                return;
            }
            if (event.key === 'Enter') {
                onEnter(event);
            }
        },
    };
}
exports.useCellKeyboardControls = useCellKeyboardControls;
